<template>
  <div>
    <section v-if="segmentsList && !loading">
      <b-tabs content-class="mt-3" class="tabs-segments" v-for="segment in segmentsList">
        <b-tab lazy>
          <div class="form-group">
            <div class="panel form-group">
              <section class="segment">
                <h5 class="form-group font-weight-bold">
                  <p>
                    <span class="badge badge-primary">{{ segment.id}}</span>
                  </p>
                  {{segment.test.module.name}}
                </h5>
                <div class="form-group text">
                  <strong v-html="segment.test.question.content"></strong>
                </div>
                <div v-if="segment.test.typeId === 1" class="segment-answers">
                  <SimpleTest :segment="segment" :preview="true"></SimpleTest>
                </div>
                <div v-if="segment.test.typeId === 2" class="segment-answers">
                  <MultipleTest :segment="segment" :preview="true"></MultipleTest>
                </div>
                <div v-if="segment.test.typeId === 3" class="segment-answers">
                  <MatchingTest :segment="segment" :preview="true"></MatchingTest>
                </div>
                <div v-if="segment.test.typeId === 4" class="segment-answers">
                  <CompoundTest :segment="segment" :preview="true"></CompoundTest>
                </div>
                <div v-if="segment.test.typeId === 5" class="segment-answers">
                  <SequenceTest :segment="segment" :preview="true"></SequenceTest>
                </div>
                <div v-if="segment.test.typeId === 6" class="segment-answers">
                  <CalculateTest :segment="segment" :preview="true"></CalculateTest>
                </div>
              </section>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </section>

    <section class="text-center mt-4" v-if="loading">
      Загружаем данные ...
    </section>

    <section class="text-center text-danger mt-4" v-if="error.length > 0">
      {{ error }}
    </section>
  </div>
</template>

<script>

import Axios from "axios";
import SimpleTest from "@/components/tests/SimpleTest";
import CompoundTest from "@/components/tests/CompoundTest";
import MultipleTest from "@/components/tests/MultipleTest";
import MatchingTest from "@/components/tests/MatchingTest";
import SequenceTest from "@/components/tests/SequenceTest";
import CalculateTest from "@/components/tests/CalculateTest";

export default {
  name: "PreviewSegmentsList",
  components: {CalculateTest, SequenceTest, MatchingTest, MultipleTest, CompoundTest, SimpleTest},
  data() {
    return {
      segmentsList: [],
      loading: true,
      error: ''
    }
  },
  created() {
    this.loading = true
    this.error = ''
    const ids = this.$route.query.ids.split(',')

    let requests = []

    ids.forEach((id) => {
      requests.push(Axios.get(`/api/v1/segments/${id}?token=${this.$route.params.token}`, {
        baseURL: process.env.VUE_APP_API_URL
      }))
    })

    Axios.all(requests)
        .then((responses) => {
          console.log(responses)
          this.segmentsList = responses.map((item) => item.data)
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.error = 'Не удалось загрузить данные, попробуйте позднее.'
        })
  }
}
</script>